import { RouteItem } from '@eastcoal/router/types/route'

import { TRADE_SESSION_LIST_PAGE_PATH } from './constants/path'

export const tradeSessionListRoute: RouteItem = {
  title: '场次列表',
  path: TRADE_SESSION_LIST_PAGE_PATH,
  hideInMenu: true,
  Component: () => import('./index')
}
